"use client"

import { useState } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card"
import { Button } from "../../ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog"
import { Calendar, Plus } from 'lucide-react'
import { AddLeaveForm } from "../../modules/add-view leaves/add-leave-form"
import { ViewLeaveHistory } from "../../modules/add-view leaves/view-leave-history"

interface AddViewLeavesPageProps {
  sidebarOpen?: boolean
}

export default function AddViewLeavesPage({sidebarOpen }: AddViewLeavesPageProps) {
  const [isAddLeaveModalOpen, setIsAddLeaveModalOpen] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  const handleLeaveAdded = () => {
    setIsAddLeaveModalOpen(false)
    // Trigger refresh of leave history by updating key
    setRefreshKey(prev => prev + 1)
  }

  return (
    <div className={`p-6 space-y-6 text-gray-900 bg-gray-50 ${!sidebarOpen ? 'max-w-none' : 'max-w-7xl mx-auto'}`}>
      <Card className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <CardHeader className="border-b border-gray-200 bg-white p-6">
          <div className="flex items-center justify-between">
            <CardTitle className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
              <Calendar className="h-6 w-6 text-blue-600" />
              View Leave History
            </CardTitle>
            <Button
              onClick={() => setIsAddLeaveModalOpen(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2"
            >
              <Plus className="h-4 w-4" />
              Add Leave
            </Button>
          </div>
        </CardHeader>
        <CardContent className="p-6">
          <ViewLeaveHistory key={refreshKey} />
        </CardContent>
      </Card>

      {/* Add Leave Modal */}
      <Dialog open={isAddLeaveModalOpen} onOpenChange={setIsAddLeaveModalOpen}>
        <DialogContent className="sm:max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>New Leave Request</DialogTitle>
          </DialogHeader>
          <AddLeaveForm
            onSubmitSuccess={handleLeaveAdded}
          />
        </DialogContent>
      </Dialog>
    </div>
  )
}
